module.exports = __webpack_public_path__ + "img/bg-servicios-2.68cde6fa.png";